(function($) {

	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){

		var $sContain50Round = $('.puff-container.swiper-container');
		var $sContainTop = $('.top-section .swiper-container');
		var $sContainQuote = $('.quote_section .swiper-container');
		var $sContainWide = $('.widescreen-section .swiper-container');

		$sContain50Round.each(function(){
		    var $this = $(this);
		    $this.swiper({
				slidesPerView: 2,
				spaceBetween: 45,
				grabCursor: true,
				keyboardControl: true,
				nextButton: '.swiper-button-next.swiper-container',
	        	prevButton: '.swiper-button-prev.swiper-container',
				loop: false,
				pagination: false,
				speed: 500,
				breakpoints: {
					1199: {
						spaceBetween: 30
	          		},
					1023: {
						slidesPerView: 1,
						spaceBetween: 0
	          		}
	        	},
				// Disable preloading of all images
				preloadImages: false,
				// Enable lazy loading
				lazy: true,
		    });
		});
		$sContainTop.each(function(){
		    var $this = $(this);
		    $this.swiper({
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				pagination: false,
				autoplay: 6000,
				speed: 1000,
	        	autoplayDisableOnInteraction: false,
				effect: 'fade',
				noSwiping: true,
				simulateTouch: false,
				// Disable preloading of all images
  				preloadImages: false,
  				// Enable lazy loading
  				lazy: true,
		    });
		});

		$sContainQuote.each(function(){
		    var $this = $(this);
		    $this.swiper({
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				pagination: false,
				autoplay: 10000,
				speed: 500,
				grabCursor: true,
				keyboardControl: true,
				nextButton: '.swiper-button-next.quote-arrow',
	        	prevButton: '.swiper-button-prev.quote-arrow'
		    });
		});

		$sContainWide.each(function(){
		    var $this = $(this);
		    $this.swiper({
				slidesPerView: 1,
				spaceBetween: 0,
				pagination: '.swiper-pagination',
				paginationClickable: true,
				loop: false,
				speed: 800,
				grabCursor: true,
				keyboardControl: true,
				nextButton: '.swiper-button-next.wide',
	        	prevButton: '.swiper-button-prev.wide',
				preventClicks: false,
				preventClicksPropagation: false,
				breakpoints: {
					767: {
						grabCursor: false,
						noSwiping: true,
						simulateTouch: false
	          		}
	        	},
				// Disable preloading of all images
				preloadImages: false,
				// Enable lazy loading
				lazy: true,
		    });
		});

	});

	/* Resize functions */
	$(window).resize(function() {

		// Get Window Width and Height
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

	});

})(jQuery);